import { useQuery } from '@tanstack/react-query';
import { geolocation } from 'services/geolocation/geolocation';
import { isTestEnvironment } from 'utils/environment/environment';
import { queryKeys } from '../queryKeys';

export const useGeolocation = () => {
  const query = useQuery({
    queryKey: queryKeys.geolocation.all,
    queryFn: () => geolocation.fetch(),
    staleTime: isTestEnvironment() ? 0 : Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  });

  return {
    ...query,
    isLoading: query.isLoading,
  };
};
